import { useEffect, useState } from 'react';

import routesHistory from 'store/history/routesHistory';
import { withDefaultPagination } from 'utils/formatters/string';

interface Params {
  backUri: string;
  config?: {
    withPartialStrategy?: boolean;
    perPage?: number;
  };
}

const useBackRoute = ({ backUri, config }: Params) => {
  // region *******************************DATA*********************************
  const [route, setRoute] = useState<LocalHistoryRoute>();

  const defaultRoute: string = withDefaultPagination(backUri, config?.perPage);
  // endregion

  // region ******************************EFFECTS*******************************
  useEffect(() => {
    const routes = routesHistory.getRoutes();
    const parsedRoutes: LocalHistoryRoute[] = routes ? JSON.parse(routes) : [];
    const neededRoute = parsedRoutes.find(({ uri }) =>
      config?.withPartialStrategy ? uri.includes(backUri) : uri === backUri
    );

    if (neededRoute) {
      setRoute({ ...neededRoute });
    }
  }, [backUri, config, setRoute]);
  // endregion

  return route ? `${route.uri}${route.query ?? ''}` : defaultRoute;
};

export default useBackRoute;
